export default __webpack_public_path__ + "assets/images/0742817c7f49f3e77a849518ec60464d.svg";